// @ts-nocheck
import { TextNode, $applyNodeReplacement } from 'lexical'
import { addClassNamesToElement } from '@lexical/utils'

export class TextVariableNode extends TextNode {
  constructor(id, label, key) {
    super(label, key)

    this.__id = id
    this.__text = label
  }

  static getType() {
    return 'variable'
  }

  static clone(node) {
    return new TextVariableNode(node.__id, node.__text, node.__key)
  }

  static importJSON(serializedNode) {
    const node = $createTextVariableNode(serializedNode.id, serializedNode.text)
    node.setFormat(serializedNode.format)
    node.setDetail(serializedNode.detail)
    node.setMode(serializedNode.mode)
    node.setStyle(serializedNode.style)

    return node
  }

  exportJSON() {
    return {
      ...super.exportJSON(),
      id: this.__id,
      type: 'variable'
    }
  }

  createDOM(config) {
    const element = super.createDOM(config)

    addClassNamesToElement(element, config.theme.variable)

    return element
  }

  canInsertTextBefore() {
    return false
  }

  canInsertTextAfter() {
    return false
  }

  isToken() {
    return true
  }

  isTextEntity() {
    return true
  }
}

export function $createTextVariableNode(id, label = '') {
  return $applyNodeReplacement(new TextVariableNode(id, label))
}

export function $isTextVariableNode(node) {
  return node instanceof TextVariableNode
}
